import { deferScript } from '@confluence/dom-helpers';

import { ResourceRecorder } from './ResourceRecorder.ts';

export class SuperbatchResourceRecorder extends ResourceRecorder {
	private includeSuperBatch: boolean;
	private isJS: boolean;

	constructor(isJS: boolean) {
		super();
		this.isJS = isJS;
		this.includeSuperBatch = false;
	}

	reset(): void {
		super.reset();
		this.includeSuperBatch = false;
	}

	includeSuperBatchResources(): void {
		this.includeSuperBatch = true;
	}

	get(): string {
		if (!this.includeSuperBatch) return '';
		if (!this.isJS) return this.resource;

		return deferScript(this.resource);
	}

	getConnect(): string {
		return '';
	}
}
